module.exports = __webpack_public_path__ + "img/buy0338.279816bd.svg";